@switch (columnName) {
  @case ('user') {
    {{ element.user?.name }}
  }
  @case ('doneBy') {
    {{ element.doneBy?.name }}
  }
  @case ('updatedAt') {
    {{ element.updatedAt | date: dateTimeFormat }}
  }
  @case ('status') {
    <app-ui-pill [name]="ADDITIONAL_TIME_APPROVAL_STATUS[element.status]"></app-ui-pill>
  }
  @case ('type') {
    {{ element.isWork ? ('manualWork' | translate) : ('manualRest' | translate) }}
  }
  @case ('department') {
    {{ element.department?.name }}
  }
  @case ('departments') {
    @for (department of element.departments; track department.id) {
      <div>
        {{ department?.name }}
      </div>
    }
    @for (departmentGroup of element.departmentGroups; track departmentGroup.id) {
      <div>
        {{ departmentGroup?.name }}
      </div>
    }
  }
  @case ('from') {
    {{ element.from | timeDisplay }}
  }
  @case ('to') {
    {{ element.to | timeDisplay }}
  }
  @case ('totalAmountOfHours') {
    {{ element.totalAmountOfHours | numberRound }}
  }
  @case ('edit') {
    <app-ui-button
      buttonType="icon-button"
      icon="edit"
      [ariaLabel]="'edit' | translate"
      (click)="buttonFunctions.edit()"
    ></app-ui-button>
  }
  @case ('delete') {
    <app-ui-button
      buttonType="icon-button"
      icon="delete"
      [ariaLabel]="'delete' | translate"
      (click)="buttonFunctions.delete()"
    ></app-ui-button>
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
